import { computed } from 'mobx';
import type { ProjectId, AssetId } from 'owa-timestream-types';
import { getSelectedProjectId, getAssets } from 'owa-timestream-store';
import { getProjectPreviewId } from 'owa-timestream-projectmanager';
import type { NearbyAssets } from '../schema';
import findNearbyPointsForAsset from '../util/findNearbyPointsForAsset';

const nearbyPoints = computed(() => {
    const projectId: ProjectId = getProjectPreviewId() ?? getSelectedProjectId();
    const assets = getAssets(projectId);

    const allNearbyPoints = new Map<AssetId, NearbyAssets>();
    assets.forEach(([id, asset]) => {
        const updatedPOI = findNearbyPointsForAsset(projectId, id);
        allNearbyPoints[id] = updatedPOI;
    });

    return allNearbyPoints;
});

export default function getNearbyPointsForAsset(assetId: AssetId): NearbyAssets | undefined {
    return nearbyPoints.get()[assetId] ?? undefined;
}
